export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: '韩漫' | '日漫' | '国漫';
  tags: string[];
  description: string;
  status: string;
  rating: number;
  views: number;
  chapters: Chapter[];
  updatedAt: string;
}

export const allComics: Comic[] = [
  {
    id: 'comic-1',
    title: '社内相亲',
    author: 'HAEBI',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20style%2C%20elegant%20female%20character%20in%20office%20attire%2C%20soft%20warm%20lighting%2C%20minimalist%20clean%20background%2C%20romantic%20drama%20aesthetic%2C%20webtoon%20style%20illustration%20with%20refined%20color%20palette%2C%20gentle%20expressions%2C%20professional%20modern%20vibe&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '韩漫',
    tags: ['恋爱', '职场', '甜宠'],
    description: '平凡上班族申夏莉代替闺蜜去相亲，本想搞砸却被公司社长一眼相中。一场始于谎言的办公室恋情就此展开，当真心与谎言交织，她该如何面对这段意外的感情？',
    status: '连载中',
    rating: 4.8,
    views: 1280000,
    chapters: [
      { id: 'ch-1-1', title: '第1话 代替相亲', number: 1, updatedAt: '2026-07-28' },
      { id: 'ch-1-2', title: '第2话 意外的相遇', number: 2, updatedAt: '2026-07-28' },
      { id: 'ch-1-3', title: '第3话 社长的关注', number: 3, updatedAt: '2026-07-27' },
      { id: 'ch-1-4', title: '第4话 无法说出的秘密', number: 4, updatedAt: '2026-07-27' },
      { id: 'ch-1-5', title: '第5话 心动的瞬间', number: 5, updatedAt: '2026-07-26' },
      { id: 'ch-1-6', title: '第6话 危机来临', number: 6, updatedAt: '2026-07-26' },
      { id: 'ch-1-7', title: '第7话 真心告白', number: 7, updatedAt: '2026-07-25' },
      { id: 'ch-1-8', title: '第8话 新的开始', number: 8, updatedAt: '2026-07-25' },
      { id: 'ch-1-9', title: '第9话 考验', number: 9, updatedAt: '2026-07-24' },
      { id: 'ch-1-10', title: '第10话 彼此的心', number: 10, updatedAt: '2026-07-24' },
    ],
    updatedAt: '2026-07-28',
  },
  {
    id: 'comic-2',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20manhwa%20cover%2C%20powerful%20male%20character%20with%20dark%20aura%2C%20dungeon%20hunter%20theme%2C%20dramatic%20lighting%20with%20purple%20and%20black%20tones%2C%20epic%20heroic%20stance%2C%20webtoon%20art%20style%2C%20intense%20atmosphere%2C%20clean%20minimal%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '韩漫',
    tags: ['奇幻', '战斗', '升级'],
    description: '被称为"人类最弱兵器"的E级猎人成振宇，在一次双重地下城任务中濒死之际，获得了神秘系统的力量。从此他成为了唯一能够"升级"的猎人，踏上了一条无人能及的成长之路。',
    status: '已完结',
    rating: 4.9,
    views: 3560000,
    chapters: [
      { id: 'ch-2-1', title: '第1话 最弱的猎人', number: 1, updatedAt: '2026-06-15' },
      { id: 'ch-2-2', title: '第2话 双重地下城', number: 2, updatedAt: '2026-06-15' },
      { id: 'ch-2-3', title: '第3话 系统的选择', number: 3, updatedAt: '2026-06-14' },
      { id: 'ch-2-4', title: '第4话 每日任务', number: 4, updatedAt: '2026-06-14' },
      { id: 'ch-2-5', title: '第5话 初次升级', number: 5, updatedAt: '2026-06-13' },
      { id: 'ch-2-6', title: '第6话 实力的证明', number: 6, updatedAt: '2026-06-13' },
      { id: 'ch-2-7', title: '第7话 新的副本', number: 7, updatedAt: '2026-06-12' },
      { id: 'ch-2-8', title: '第8话 觉醒', number: 8, updatedAt: '2026-06-12' },
    ],
    updatedAt: '2026-06-15',
  },
  {
    id: 'comic-3',
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20cover%20art%2C%20male%20character%20with%20spiky%20hair%20and%20supernatural%20powers%2C%20dark%20fantasy%20theme%2C%20jujutsu%20sorcerer%20aesthetic%2C%20dynamic%20action%20pose%2C%20red%20and%20black%20color%20scheme%2C%20manga%20illustration%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '日漫',
    tags: ['热血', '战斗', '奇幻'],
    description: '高中生虎杖悠仁偶然吞下诅咒之王两面宿傩的手指，从此踏入了咒术的世界。为了收集散落各地的宿傩手指，他加入东京都立咒术高等专门学校，与伙伴们一起对抗诅咒。',
    status: '连载中',
    rating: 4.7,
    views: 2890000,
    chapters: [
      { id: 'ch-3-1', title: '第1话 两面宿傩', number: 1, updatedAt: '2026-07-30' },
      { id: 'ch-3-2', title: '第2话 秘密处刑', number: 2, updatedAt: '2026-07-30' },
      { id: 'ch-3-3', title: '第3话 为了自己', number: 3, updatedAt: '2026-07-29' },
      { id: 'ch-3-4', title: '第4话 咒术高专', number: 4, updatedAt: '2026-07-29' },
      { id: 'ch-3-5', title: '第5话 诅咒之王', number: 5, updatedAt: '2026-07-28' },
      { id: 'ch-3-6', title: '第6话 领域展开', number: 6, updatedAt: '2026-07-28' },
    ],
    updatedAt: '2026-07-30',
  },
  {
    id: 'comic-4',
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20comedy%20manga%20cover%20featuring%20a%20family%20of%20three%2C%20spy%20father%20assassin%20mother%20and%20telepath%20daughter%2C%20warm%20colorful%20illustration%20style%2C%20playful%20mood%2C%20clean%20white%20background%2C%20charming%20character%20designs%2C%20manga%20art%20aesthetic&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '日漫',
    tags: ['喜剧', '家庭', '间谍'],
    description: '为了执行秘密任务，顶尖间谍"黄昏"需要组建一个临时家庭。他找来的女儿是会读心的超能力者，妻子是暗杀者。三人各怀秘密，却组成了一个温馨而爆笑的家庭。',
    status: '连载中',
    rating: 4.9,
    views: 4100000,
    chapters: [
      { id: 'ch-4-1', title: '第1话 任务开始', number: 1, updatedAt: '2026-07-31' },
      { id: 'ch-4-2', title: '第2话 女儿的选择', number: 2, updatedAt: '2026-07-31' },
      { id: 'ch-4-3', title: '第3话 妻子的秘密', number: 3, updatedAt: '2026-07-30' },
      { id: 'ch-4-4', title: '第4话 家庭日常', number: 4, updatedAt: '2026-07-30' },
      { id: 'ch-4-5', title: '第5话 入学面试', number: 5, updatedAt: '2026-07-29' },
      { id: 'ch-4-6', title: '第6话 校园生活', number: 6, updatedAt: '2026-07-29' },
      { id: 'ch-4-7', title: '第7话 危机逼近', number: 7, updatedAt: '2026-07-28' },
      { id: 'ch-4-8', title: '第8话 家人的羁绊', number: 8, updatedAt: '2026-07-28' },
    ],
    updatedAt: '2026-07-31',
  },
  {
    id: 'comic-5',
    title: '斗罗大陆',
    author: '唐家三少 / 穆逢春',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%2C%20fantasy%20martial%20arts%20theme%2C%20young%20male%20character%20with%20blue%20hair%20and%20spirit%20ring%20aura%2C%20epic%20cultivation%20aesthetic%2C%20Tang%20San%20character%2C%20mystical%20atmosphere%2C%20clean%20illustration%20style%2C%20Chinese%20comic%20art&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '国漫',
    tags: ['玄幻', '热血', '修炼'],
    description: '唐门外门弟子唐三因偷学内门绝学被逼跳崖明志，却意外穿越到斗罗大陆。在这片武魂的世界里，他凭借唐门绝学和双生武魂，一步步踏上巅峰强者之路。',
    status: '连载中',
    rating: 4.8,
    views: 5200000,
    chapters: [
      { id: 'ch-5-1', title: '第1话 穿越斗罗', number: 1, updatedAt: '2026-07-31' },
      { id: 'ch-5-2', title: '第2话 武魂觉醒', number: 2, updatedAt: '2026-07-31' },
      { id: 'ch-5-3', title: '第3话 诺丁学院', number: 3, updatedAt: '2026-07-30' },
      { id: 'ch-5-4', title: '第4话 大师玉小刚', number: 4, updatedAt: '2026-07-30' },
      { id: 'ch-5-5', title: '第5话 魂环获取', number: 5, updatedAt: '2026-07-29' },
      { id: 'ch-5-6', title: '第6话 史莱克学院', number: 6, updatedAt: '2026-07-29' },
      { id: 'ch-5-7', title: '第7话 七怪聚首', number: 7, updatedAt: '2026-07-28' },
      { id: 'ch-5-8', title: '第8话 初次配合', number: 8, updatedAt: '2026-07-28' },
    ],
    updatedAt: '2026-07-31',
  },
  {
    id: 'comic-6',
    title: '全职高手',
    author: '蝴蝶蓝 / 常盘勇者',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20manhua%20cover%2C%20cool%20male%20gamer%20character%20with%20headphones%2C%20competitive%20gaming%20theme%2C%20Ye%20Xiu%20character%20design%2C%20modern%20sleek%20art%20style%2C%20clean%20composition%2C%20gaming%20aesthetic%2C%20professional%20esports%20vibe&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '国漫',
    tags: ['电竞', '热血', '竞技'],
    description: '被誉为"荣耀教科书"的顶尖高手叶修，因种种原因被俱乐部驱逐。离开职业圈的他栖身于一家网吧成了网管，但凭借十年游戏经验和一把自制武器，他决定重新出发，重返巅峰。',
    status: '连载中',
    rating: 4.9,
    views: 4800000,
    chapters: [
      { id: 'ch-6-1', title: '第1话 被驱逐的高手', number: 1, updatedAt: '2026-07-30' },
      { id: 'ch-6-2', title: '第2话 网吧重生', number: 2, updatedAt: '2026-07-30' },
      { id: 'ch-6-3', title: '第3话 第十区', number: 3, updatedAt: '2026-07-29' },
      { id: 'ch-6-4', title: '第4话 千机伞', number: 4, updatedAt: '2026-07-29' },
      { id: 'ch-6-5', title: '第5话 新角色', number: 5, updatedAt: '2026-07-28' },
      { id: 'ch-6-6', title: '第6话 君莫笑', number: 6, updatedAt: '2026-07-28' },
    ],
    updatedAt: '2026-07-30',
  },
  {
    id: 'comic-7',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20beautiful%20princess%20character%20with%20long%20blonde%20hair%20in%20elegant%20dress%2C%20royal%20palace%20theme%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20webtoon%20art%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '韩漫',
    tags: ['奇幻', '恋爱', '穿越'],
    description: '一觉醒来变成了小说中的公主，还是注定要被亲生父亲杀死的悲剧角色！为了改变命运，她必须在这座冰冷的皇宫中努力获得父皇的爱与认可。',
    status: '已完结',
    rating: 4.8,
    views: 2150000,
    chapters: [
      { id: 'ch-7-1', title: '第1话 成为公主', number: 1, updatedAt: '2026-06-20' },
      { id: 'ch-7-2', title: '第2话 冷血的父皇', number: 2, updatedAt: '2026-06-20' },
      { id: 'ch-7-3', title: '第3话 第一次微笑', number: 3, updatedAt: '2026-06-19' },
      { id: 'ch-7-4', title: '第4话 皇族的宴会', number: 4, updatedAt: '2026-06-19' },
      { id: 'ch-7-5', title: '第5话 命运的转折', number: 5, updatedAt: '2026-06-18' },
      { id: 'ch-7-6', title: '第6话 温暖的亲情', number: 6, updatedAt: '2026-06-18' },
    ],
    updatedAt: '2026-06-20',
  },
  {
    id: 'comic-8',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20manga%20cover%2C%20young%20male%20swordsman%20with%20green%20checkered%20haori%2C%20nichirin%20blade%2C%20Taisho%20era%20aesthetic%2C%20water%20breathing%20effect%2C%20manga%20illustration%20style%2C%20dark%20atmospheric%20background%2C%20clean%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '日漫',
    tags: ['热血', '战斗', '和风'],
    description: '大正时代的日本，少年灶门炭治郎全家惨遭鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹恢复人类之身，炭治郎踏上了成为鬼杀队剑士的征程。',
    status: '已完结',
    rating: 4.9,
    views: 6200000,
    chapters: [
      { id: 'ch-8-1', title: '第1话 残酷', number: 1, updatedAt: '2026-05-10' },
      { id: 'ch-8-2', title: '第2话 培育者', number: 2, updatedAt: '2026-05-10' },
      { id: 'ch-8-3', title: '第3话 最终选拔', number: 3, updatedAt: '2026-05-09' },
      { id: 'ch-8-4', title: '第4话 我的乌鸦', number: 4, updatedAt: '2026-05-09' },
      { id: 'ch-8-5', title: '第5话 浅草', number: 5, updatedAt: '2026-05-08' },
      { id: 'ch-8-6', title: '第6话 鼓之宅邸', number: 6, updatedAt: '2026-05-08' },
      { id: 'ch-8-7', title: '第7话 火之神乐', number: 7, updatedAt: '2026-05-07' },
      { id: 'ch-8-8', title: '第8话 柱合会议', number: 8, updatedAt: '2026-05-07' },
    ],
    updatedAt: '2026-05-10',
  },
  {
    id: 'comic-9',
    title: '一念永恒',
    author: '耳根',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%2C%20young%20male%20immortal%20cultivator%20in%20white%20robes%2C%20fantasy%20xianxia%20theme%2C%20mystical%20energy%20effects%2C%20mountain%20landscape%2C%20Chinese%20comic%20art%20style%2C%20clean%20ethereal%20atmosphere&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '国漫',
    tags: ['修仙', '搞笑', '热血'],
    description: '白小纯，一个怕死到极点的修仙者，为了长生不老踏上了修仙之路。他的怕死让他创造出各种奇葩功法，搞笑的修仙之旅就此展开，而他追求长生的执念却比任何人都坚定。',
    status: '连载中',
    rating: 4.6,
    views: 1950000,
    chapters: [
      { id: 'ch-9-1', title: '第1话 怕死的白小纯', number: 1, updatedAt: '2026-07-29' },
      { id: 'ch-9-2', title: '第2话 香云山', number: 2, updatedAt: '2026-07-29' },
      { id: 'ch-9-3', title: '第3话 不死长生功', number: 3, updatedAt: '2026-07-28' },
      { id: 'ch-9-4', title: '第4话 灵尾鸡', number: 4, updatedAt: '2026-07-28' },
      { id: 'ch-9-5', title: '第5话 丹道天才', number: 5, updatedAt: '2026-07-27' },
      { id: 'ch-9-6', title: '第6话 宗门大比', number: 6, updatedAt: '2026-07-27' },
    ],
    updatedAt: '2026-07-29',
  },
  {
    id: 'comic-10',
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20beauty%20romance%20manhwa%20cover%2C%20stunning%20female%20character%20with%20perfect%20makeup%2C%20before%20and%20after%20transformation%20theme%2C%20modern%20fashion%20aesthetic%2C%20webtoon%20style%2C%20glamorous%20yet%20clean%20composition%2C%20soft%20lighting&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '韩漫',
    tags: ['恋爱', '校园', '美妆'],
    description: '因为外貌被霸凌的任朱静，通过化妆技巧华丽变身成为校园女神。但她的素颜秘密只有转学生李修豪知道，一段关于外表、自信与真爱的青春故事从此展开。',
    status: '已完结',
    rating: 4.7,
    views: 3400000,
    chapters: [
      { id: 'ch-10-1', title: '第1话 素颜的秘密', number: 1, updatedAt: '2026-04-15' },
      { id: 'ch-10-2', title: '第2话 化妆的力量', number: 2, updatedAt: '2026-04-15' },
      { id: 'ch-10-3', title: '第3话 转学生', number: 3, updatedAt: '2026-04-14' },
      { id: 'ch-10-4', title: '第4话 天台相遇', number: 4, updatedAt: '2026-04-14' },
      { id: 'ch-10-5', title: '第5话 两个人的秘密', number: 5, updatedAt: '2026-04-13' },
      { id: 'ch-10-6', title: '第6话 心跳加速', number: 6, updatedAt: '2026-04-13' },
    ],
    updatedAt: '2026-04-15',
  },
  {
    id: 'comic-11',
    title: '进击的巨人',
    author: '谏山创',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%2C%20attack%20on%20titan%20theme%2C%20soldiers%20with%20vertical%20maneuvering%20equipment%2C%20colossal%20titan%20silhouette%2C%20dramatic%20intense%20atmosphere%2C%20manga%20art%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '日漫',
    tags: ['黑暗', '战斗', '悬疑'],
    description: '巨人的突然出现将人类逼入高墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬，立誓消灭所有巨人。加入调查兵团后，他逐渐揭开了巨人和这个世界背后隐藏的惊天秘密。',
    status: '已完结',
    rating: 4.9,
    views: 7500000,
    chapters: [
      { id: 'ch-11-1', title: '第1话 致两千年后的你', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch-11-2', title: '第2话 那一天', number: 2, updatedAt: '2026-03-01' },
      { id: 'ch-11-3', title: '第3话 解散式之夜', number: 3, updatedAt: '2026-02-28' },
      { id: 'ch-11-4', title: '第4话 初阵', number: 4, updatedAt: '2026-02-28' },
      { id: 'ch-11-5', title: '第5话 刀刃', number: 5, updatedAt: '2026-02-27' },
      { id: 'ch-11-6', title: '第6话 巨人之森', number: 6, updatedAt: '2026-02-27' },
      { id: 'ch-11-7', title: '第7话 女型巨人', number: 7, updatedAt: '2026-02-26' },
      { id: 'ch-11-8', title: '第8话 战士', number: 8, updatedAt: '2026-02-26' },
    ],
    updatedAt: '2026-03-01',
  },
  {
    id: 'comic-12',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20fantasy%20manhua%20cover%2C%20beautiful%20fox%20spirit%20girl%20with%20long%20flowing%20hair%2C%20traditional%20Chinese%20elements%2C%20romantic%20ancient%20aesthetic%2C%20soft%20warm%20colors%2C%20Chinese%20comic%20style%2C%20ethereal%20atmosphere&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '国漫',
    tags: ['恋爱', '奇幻', '古风'],
    description: '以红娘为职业的狐妖涂山苏苏，为前世恋人牵线续缘。人与妖之间的情感纠葛，跨越千年的爱恨情仇，在一个个感人至深的故事中徐徐展开。',
    status: '连载中',
    rating: 4.7,
    views: 2600000,
    chapters: [
      { id: 'ch-12-1', title: '第1话 狐妖红娘', number: 1, updatedAt: '2026-07-28' },
      { id: 'ch-12-2', title: '第2话 下沙篇', number: 2, updatedAt: '2026-07-28' },
      { id: 'ch-12-3', title: '第3话 前世今生', number: 3, updatedAt: '2026-07-27' },
      { id: 'ch-12-4', title: '第4话 白月初', number: 4, updatedAt: '2026-07-27' },
      { id: 'ch-12-5', title: '第5话 续缘任务', number: 5, updatedAt: '2026-07-26' },
      { id: 'ch-12-6', title: '第6话 王权富贵', number: 6, updatedAt: '2026-07-26' },
    ],
    updatedAt: '2026-07-28',
  },
];

export const categories = ['全部', '韩漫', '日漫', '国漫'] as const;

export const categoryInfo: Record<string, { name: string; description: string; icon: string }> = {
  '全部': { name: '全部漫画', description: '海量漫画资源，韩漫日漫国漫一网打尽', icon: 'ri-book-read-line' },
  '韩漫': { name: '韩漫', description: '精选韩国漫画，恋爱、奇幻、热血题材丰富', icon: 'ri-kakao-talk-line' },
  '日漫': { name: '日漫', description: '经典日本漫画，热血、悬疑、少年漫一应俱全', icon: 'ri-sun-line' },
  '国漫': { name: '国漫', description: '国产漫画崛起之作，玄幻、古风、电竞精彩纷呈', icon: 'ri-china-railway-line' },
};